import { Title } from './Title';
import { Text } from './Text';

export const Typography = {
  Title,
  Text
};
